import { func_file, isArrayNotEmpty, isDateValid, isNumber, isNumberValid, reformatNumberDecimalPlaces } from 'functions';
import { Toaster } from 'components/notification/Toaster';
import moment from 'moment';

export function exportData(data, selectedMonth) {
    if (isArrayNotEmpty(data)) {
        if (isDateValid(selectedMonth)) {
            // Set Header Names
            let currentMoment = moment(selectedMonth);
            let currentMonthPos = currentMoment.month();
            let headers = [
                // Top
                [
                    "",
                    currentMoment.month(currentMonthPos - 2).format("MMMM (YYYY)"), "","",
                    currentMoment.month(currentMonthPos - 1).format("MMMM (YYYY)"), "","",
                    currentMoment.month(currentMonthPos).format("MMMM (YYYY)"), "","",
                    currentMoment.month(currentMonthPos - 2).format("MMMM (YYYY)") + " - " + currentMoment.month(currentMonthPos).format("MMMM (YYYY)"), "","",
                ],
                // Bottom
                [   
                    "",

                    "Total Charges (RM)",
                    "Total Outlets [Chrg/Outlet(RM)]",
                    "Total Clients [Chrg/Client(RM)]",
                    // "Total Charges Per Outlet (RM)",
                    // "Total Charges Per Client (RM)",

                    "Total Charges (RM)",
                    "Total Outlets [Chrg/Outlet(RM)]",
                    "Total Clients [Chrg/Client(RM)]",
                    // "Total Charges Per Outlet (RM)",
                    // "Total Charges Per Client (RM)",

                    "Total Charges (RM)",
                    "Total Outlets [Chrg/Outlet(RM)]",
                    "Total Clients [Chrg/Client(RM)]",
                    // "Total Charges Per Outlet (RM)",
                    // "Total Charges Per Client (RM)",

                    "Average Charges (RM)",
                    "Average Outlets [Chrg/Outlet(RM)]",
                    "Average Clients [Chrg/Client(RM)]",
                    // "Average Charges Per Outlet (RM)",
                    // "Average Charges Per Client (RM)",
                ]
            ];

            // Merged cells
            let mergedCells = [
                {
                    s: { c: 1, r: 0 }, 
                    e: { c: 3, r: 0 } 
                },
                {
                    s: { c: 4, r: 0 }, 
                    e: { c: 6, r: 0 } 
                },
                {
                    s: { c: 7, r: 0 }, 
                    e: { c: 9, r: 0 } 
                },
                {
                    s: { c: 10, r: 0 }, 
                    e: { c: 12, r: 0 } 
                },
            ];

            // Columns Widths
            let secondRowHeaders = headers[1];
            let headerWidths = secondRowHeaders.map((header) => {
                return {
                    wch: header.length
                }
            });
            headerWidths.splice(0, 1);
            let columnWidths = [
                {
                    wch: "81 - 100 Outlets".length
                },
                ...headerWidths
            ]

            // Rows with left column labels
            let rowsLabels = [
                ["0 - 2 Outlets"],
                ["3 - 5 Outlets"],
                ["6 - 10 Outlets"],
                ["11 - 20 Outlets"],
                ["21 - 50 Outlets"],
                ["51 - 80 Outlets"],
                ["81 - 100 Outlets"],
                ["Total"]
            ]

            // Set rows data
            let rows = data.map((rowDetail) => {
                let avgOutletCharge2 = isNumberValid(rowDetail?.Avg_By_Outlet2)? reformatNumberDecimalPlaces(rowDetail?.Avg_By_Outlet2):"-";
                let avgClientCharge2 = isNumberValid(rowDetail?.Avg_By_Client2)? reformatNumberDecimalPlaces(rowDetail?.Avg_By_Client2):"-";

                let avgOutletCharge1 = isNumberValid(rowDetail?.Avg_By_Outlet1)? reformatNumberDecimalPlaces(rowDetail?.Avg_By_Outlet1):"-";
                let avgClientCharge1 = isNumberValid(rowDetail?.Avg_By_Client1)? reformatNumberDecimalPlaces(rowDetail?.Avg_By_Client1):"-";

                let avgOutletCharge0 = isNumberValid(rowDetail?.Avg_By_Outlet0)? reformatNumberDecimalPlaces(rowDetail?.Avg_By_Outlet0):"-";
                let avgClientCharge0 = isNumberValid(rowDetail?.Avg_By_Client0)? reformatNumberDecimalPlaces(rowDetail?.Avg_By_Client0):"-";

                let avgOfAvgOutletCharges = isNumberValid(rowDetail?.averageChargePerOutlet)? reformatNumberDecimalPlaces(rowDetail?.averageChargePerOutlet):"-";
                let avgOfAvgClientCharges = isNumberValid(rowDetail?.averageChargePerClient)? reformatNumberDecimalPlaces(rowDetail?.averageChargePerClient):"-";

                return [
                    isNumberValid(rowDetail?.Total_Charges2)? reformatNumberDecimalPlaces(rowDetail?.Total_Charges2):"",
                    isNumberValid(rowDetail?.Total_Outlet2)? rowDetail?.Total_Outlet2 + " (" + avgOutletCharge2 + ")":"",
                    isNumberValid(rowDetail?.Total_Client2)? rowDetail?.Total_Client2 + " (" + avgClientCharge2 + ")":"",
                    // isNumberValid(rowDetail?.Avg_By_Outlet2)? rowDetail?.Avg_By_Outlet2:"",
                    // isNumberValid(rowDetail?.Avg_By_Client2)? rowDetail?.Avg_By_Client2:"",

                    isNumberValid(rowDetail?.Total_Charges1)? reformatNumberDecimalPlaces(rowDetail?.Total_Charges1):"",
                    isNumberValid(rowDetail?.Total_Outlet1)? rowDetail?.Total_Outlet1 + " (" + avgOutletCharge1 + ")":"",
                    isNumberValid(rowDetail?.Total_Client1)? rowDetail?.Total_Client1 + " (" + avgClientCharge1 + ")":"",
                    // isNumberValid(rowDetail?.Avg_By_Outlet1)? rowDetail?.Avg_By_Outlet1:"",
                    // isNumberValid(rowDetail?.Avg_By_Client1)? rowDetail?.Avg_By_Client1:"",

                    isNumberValid(rowDetail?.Total_Charges0)? reformatNumberDecimalPlaces(rowDetail?.Total_Charges0):"",
                    isNumberValid(rowDetail?.Total_Outlet0)? rowDetail?.Total_Outlet0 + " (" + avgOutletCharge0 + ")":"",
                    isNumberValid(rowDetail?.Total_Client0)? rowDetail?.Total_Client0 + " (" + avgClientCharge0 + ")":"",
                    // isNumberValid(rowDetail?.Avg_By_Outlet0)? rowDetail?.Avg_By_Outlet0:"",
                    // isNumberValid(rowDetail?.Avg_By_Client0)? rowDetail?.Avg_By_Client0:"",

                    isNumberValid(rowDetail?.averageCharges)? reformatNumberDecimalPlaces(rowDetail?.averageCharges):"",
                    isNumberValid(rowDetail?.averageOutlets)? rowDetail?.averageOutlets + " (" + avgOfAvgOutletCharges + ")":"",
                    isNumberValid(rowDetail?.averageClients)? rowDetail?.averageClients + " (" + avgOfAvgClientCharges + ")":"",
                    // isNumberValid(rowDetail?.averageChargePerOutlet)? rowDetail?.averageChargePerOutlet:"",
                    // isNumberValid(rowDetail?.averageChargePerClient)? rowDetail?.averageChargePerClient:"",
                ]
            });

            func_file.generateFile_XLSX("Revenue Report", "Revenue", headers, rows, rowsLabels, mergedCells, columnWidths);
        }
        else {
            Toaster({
                error: "error",
                msg: "Invalid Date"
            })
        }

    }
    else {
        Toaster({
            error: "error",
            msg: "No data searched to export"
        })
    }
}